import React, { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  if (!offline) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10000,
      background: '#dc2626', color: '#fff',
      padding: '10px 20px', textAlign: 'center',
      fontSize: 13, fontWeight: 600,
    }}>
      ⚠ 网络连接已断开，请检查网络后刷新页面
    </div>
  );
}
